import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../../contexts/AuthContext';
import { useEmpresaAuth } from '../../../contexts/EmpresaAuthContext';
import { useStaffAuth } from '../../../contexts/StaffAuthContext';
import { usePromoterAuth } from '../../../contexts/PromoterAuthContext';
import Button from '../Button/Button';
import { 
  HeaderContainer, 
  HeaderContent, 
  Logo, 
  Navigation, 
  NavLink,
  UserSection,
  UserName,
} from './Header.styles';

const Header = ({ type = 'user' }) => {
  const { user, logout } = useAuth();
  const { empresa, logout: empresaLogout } = useEmpresaAuth();
  const { staff, logout: staffLogout } = useStaffAuth();
  const { promoter, logout: promoterLogout } = usePromoterAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    if (type === 'staff') {
      staffLogout();
      navigate('/staff/login');
    } else if (type === 'promoter') {
      promoterLogout();
      navigate('/promotor/login');
    } else if (type === 'empresa') {
      empresaLogout();
      navigate('/empresa/login');
    } else {
      logout();
      navigate('/');
    }
  };

  // Solo el rol `operator` vende (permissions.sell viene de /api/auth/staff/me).
  const canSell = Boolean(staff && (staff.permissions ? staff.permissions.sell : staff.role === 'operator'));

  const currentUser = type === 'staff' ? staff : type === 'promoter' ? promoter : type === 'empresa' ? empresa : user;
  const loginPath = type === 'staff'
    ? '/staff/login'
    : type === 'promoter' ? '/promotor/login' : type === 'empresa' ? '/empresa/login' : '/login';
  const registerPath = type === 'promoter'
    ? '/promotor/register'
    : type === 'empresa' ? '/empresa/register' : '/register';

  return (
    <HeaderContainer>
      <HeaderContent>
        <Logo to="/" aria-label="BokerHub, ir al inicio">
          <img
            src="/assets/logos/logo-color.png"
            alt="BokerHub"
          />
        </Logo>
        
        <Navigation>
          {type === 'user' && (
            <>
              <NavLink to="/search">Buscar</NavLink>
              {/* <NavLink to="/activities">Actividades</NavLink> */}
            </>
          )}
          
          {type === 'staff' && staff && (
            <>
              <NavLink to="/staff/scanner">Escáner QR</NavLink>
              {canSell && (
                <>
                  <NavLink to="/staff/sales/new">Vender</NavLink>
                  <NavLink to="/staff/sales">Mis ventas</NavLink>
                </>
              )}
            </>
          )}

          {type === 'promoter' && promoter && (
            <NavLink to="/promotor">Mi panel</NavLink>
          )}

          {type === 'empresa' && empresa && (
            <>
              <NavLink to="/empresa/dashboard">Dashboard</NavLink>
              <NavLink to="/empresa/activities">Actividades</NavLink>
              <NavLink to="/empresa/reservations">Reservas</NavLink>
              <NavLink to="/empresa/sales/new">Vender</NavLink>
              <NavLink to="/empresa/sales">Ventas</NavLink>
              <NavLink to="/empresa/scanner">Scanner QR</NavLink>
              <NavLink to="/empresa/promotores">Promotores</NavLink>
              <NavLink to="/empresa/staff">Equipo</NavLink>
              <NavLink to="/empresa/settings">Configuración</NavLink>
            </>
          )}
        </Navigation>

        <UserSection>
          {currentUser ? (
            <>
              <UserName>Hola, {currentUser.name}</UserName>
              {type === 'user' && <NavLink to="/profile">Mi Perfil</NavLink>}
              <Button variant="secondary" size="small" onClick={handleLogout}>
                Salir
              </Button>
            </>
          ) : (
            <>
              <Button 
                variant="ghost" 
                size="small"
                onClick={() => navigate(loginPath)}
              >
                Iniciar Sesión
              </Button>
              {type !== 'staff' && (
                <Button 
                  size="small"
                  onClick={() => navigate(registerPath)}
                >
                  Registrarse
                </Button>
              )}
            </>
          )}
        </UserSection>
      </HeaderContent>
    </HeaderContainer>
  );
};

export default Header;
